import {
  THALAMOS_ADMIN_ROLE,
  THALAMOS_ORGANISATION_ID,
} from "../types/thalamos.js";
import type { UserMembership } from "../types/user.js";

/**
 * Whether a user membership is `thalamos_admin` held at the Thalamos
 * organisation.
 *
 * Both halves are required: a `thalamos_admin` membership recorded at a
 * customer organisation confers nothing, so the organisation is checked here
 * rather than by every caller remembering to.
 */
export const isThalamosAdminMembership = (
  membership:
    Pick<UserMembership, "organisationId" | "role"> | null | undefined,
): boolean =>
  membership?.role === THALAMOS_ADMIN_ROLE &&
  membership.organisationId === THALAMOS_ORGANISATION_ID;
